import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(MotionPathPlugin);

let dist = 2;
let smallRadius = 2;
// let bigRadius = 5;
const cx = 0;
const cy = 0;

if (window.innerWidth < 960) {
  dist = 2;
  smallRadius = 1;
  // bigRadius = 2;
}

function getCirclePath(radius) {
  return (
    'M ' +
    cx +
    ' ' +
    cy +
    ' m ' +
    radius * -1 +
    ', 0 a ' +
    radius +
    ',' +
    radius +
    ' 0 1,0 ' +
    radius * 2 +
    ',0 a ' +
    radius +
    ',' +
    radius +
    ' 0 1,0 ' +
    radius * -2 +
    ',0'
  );
}

function startAnimation() {
  // gsap.timeline({ repeat: -1, yoyo: false })
  // .to(
  //   '.graphic-octopus-legs',
  //   {
  //     motionPath: {
  //       path: getCirclePath(smallRadius),
  //       type: 'quadratic',
  //       alignOrigin: [0.5, 0.5],
  //     },
  //     duration: 2,
  //     ease: 'none'
  //   }
  // );

  gsap.timeline({ repeat: -1, yoyo: false }).to('.graphic-octopus', {
    motionPath: {
      path: getCirclePath(smallRadius),
      type: 'quadratic',
      alignOrigin: [0.5, 0.5],
    },
    duration: 2,
    ease: 'none',
  });

  gsap.timeline({ repeat: -1, yoyo: true }).to('.graphic-sea-front', {
    duration: 2,
    ease: 'none',
    x: 0,
    y: -dist * 3,
  });

  gsap
    .timeline({ repeat: -1, yoyo: true })
    .to('.graphic-sea-back', { duration: 3, ease: 'none', x: 0, y: dist });

  gsap
    .timeline({ repeat: -1, yoyo: true })
    .to('.graphic-sea-rocks', { duration: 1, ease: 'none', x: dist, y: -dist });

  gsap
    .timeline({ repeat: -1, yoyo: true })
    .to('.graphic-ship', {
      duration: 2,
      ease: 'none',
      rotate: -5,
      x: 0,
      y: dist,
    })
    .to('.graphic-ship', {
      duration: 2,
      ease: 'none',
      rotate: 5,
      x: 0,
      y: dist * 3,
    });

  gsap
    .timeline({ repeat: -1, yoyo: true })
    .to('.graphic-sky', { duration: 3, ease: 'none', x: dist * 3, y: 0 });

  gsap.timeline({ repeat: -1, yoyo: true }).to('.graphic-birds', {
    duration: 2,
    ease: 'power1.inOut',
    x: dist * 3,
    y: dist,
  });
}

const dura = 0.5;
const dela = 0.2;
// let count = 0;

function appear() {
  let del = 0;
  document.querySelectorAll('.graphic__layer').forEach(function (el) {
    // count += 1;
    if (!el.querySelector('img').classList.value.includes('octopus-body')) {
      del += dela;
    }
    gsap.timeline().to(el, {
      duration: dura,
      delay: del,
      y: 0,
      opacity: 1,
      ease: 'power1.out',
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  appear();
  startAnimation();
});
